import { useState } from "react";
import GetIcon from "../../../utils/Icon";
import { Field } from "formik";
import CameraInput from "../../common/Form/Fields/CameraInput";
import FingerprintInput from "../Form/Fields/FingerprintInput";

const CustomField = ({ field, values }) => {
    const [showPassword, setShowPassword] = useState(false);
    const readOnly = true;

    switch (field.type) {

        case "finger": {
            const photoUrl = `data:image/png;base64,${values[field.name]}`;
            return (
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                    <img src={photoUrl} className="h-32 w-32 mx-auto mb-2 rounded-lg object-cover" />
                </div>
            );
        }
        

        case "file":
            const fileUrl = values[field.name];
            const photoUrl = fileUrl ? `${process.env.REACT_APP_API_URL}${fileUrl}` : null;

            return (
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                    {fileUrl ? (
                        field.format === "base64" ? (
                            <img
                                src={fileUrl}
                                alt={field.label}
                                className="h-32 w-32 mx-auto mb-2 rounded-lg object-cover"
                            />
                        ) : (
                            photoUrl && (
                                <img
                                    src={photoUrl}
                                    alt={field.label}
                                    className="h-32 w-32 mx-auto mb-2 rounded-lg object-cover"
                                />
                            )
                        )
                    ) : (
                        <div className="text-purple-600 flex justify-center items-center flex-col">
                            {/* Placeholder for when no file is selected */}
                        </div>
                    )}
                </div>
            );

        case "select":
            return (
                <Field as="select" name={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    disabled={readOnly}>
                    <option value="">{`Select ${field.label}`}</option>
                    {field.options.map((option, i) => (
                        <option key={i} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Field>
            );

        default:
            return (
                <div className="relative w-full">
                    <Field
                        type={field?.type === "password" && showPassword ? "text" : field?.type}
                        name={field?.name}
                        placeholder={field?.placeholder}
                        className={`w-full px-4 py-2 border border-gray-300 rounded-lg
                             ${readOnly ? "bg-gray-100 cursor-not-allowed" : ""}`}
                        readOnly={readOnly}
                    />
                    {field.type === "password" && !readOnly && (
                        <span
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <GetIcon
                                iconName={showPassword ? "FaEyeSlash" : "FaEye"}
                                size={20}
                                design="text-gray-600"
                            />
                        </span>
                    )}
                </div>
            );
    }
};

export default CustomField;
